import Style from "../scss/text.module.scss";

export function TitleH3Component(props) {
    return (
        <h3 className={`${Style.h3} ${props.styleGroup}`}>{props.children}</h3>
    );
}